import { RootState } from '../state/configure_store'

export type AuthSessionSnapshot = {
  refreshToken: string;
  sessionGeneration: number;
}

const getSessionGeneration = (state: RootState) =>
  state.token.sessionGeneration ?? 0

export const createAuthSessionSnapshot = (
  state: RootState
): AuthSessionSnapshot | null => {
  const refreshToken = state.token.token?.refreshToken

  if (!refreshToken) {
    return null
  }

  return {
    refreshToken,
    sessionGeneration: getSessionGeneration(state)
  }
}

export const getAuthSessionSnapshotStatus = (
  state: RootState,
  snapshot: AuthSessionSnapshot
) => {
  if (getSessionGeneration(state) !== snapshot.sessionGeneration) {
    return 'logged_out'
  }

  if (state.token.token?.refreshToken !== snapshot.refreshToken) {
    return 'superseded'
  }

  return 'current'
}
